import { ref as S, computed as u, defineComponent as M, toRefs as D, onMounted as O, watch as U, resolveComponent as y, openBlock as i, createElementBlock as c, normalizeClass as g, createBlock as f, resolveDynamicComponent as R, createCommentVNode as p, withCtx as W, createTextVNode as Y, toDisplayString as w, createElementVNode as j, renderSlot as Z } from "vue";
import { F as q, a as G } from "../../../vee-validate.esm-c4518011.js";
import { sanitize as J } from "../../../utils/htmlSanitizer.js";
import K from "../../atoms/VIcon/VIcon.js";
import Q from "../../atoms/VIconButton/VIconButton.js";
import X from "../../atoms/VText/VText.js";
import { U as V } from "../../../constants-69d32a0e.js";
import { _ as x } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../utils/tailwindUnitsConverter.js";
function _(e, l) {
  const a = S(!1), n = u(() => ({
    symbol: a.value === !1 ? "view" : "hide"
  })), r = () => {
    a.value = !a.value, e.value && e.value.focus();
  }, b = u(() => !a.value && l.enableShowPassword ? "showPassword" : "hidePassword"), d = u(() => {
    let o = l.type;
    return l.enableShowPassword && (o = a.value ? "text" : "password"), o;
  });
  return {
    handleShowHidePassword: r,
    fieldType: d,
    togglePasswordIcon: n,
    togglePasswordButtonLabel: b
  };
}
function ee(e) {
  const l = e, a = l !== null ? window.getComputedStyle(l) : null;
  a !== null && (l.style.height = "auto", l.style.height = `calc(${a.borderTopWidth} + ${a.borderBottomWidth} + ${l.scrollHeight}px)`, parseFloat(l.style.height) >= parseFloat(l.style.maxHeight) ? (l.style.overflowY = "scroll", l.style.height = l.style.maxHeight) : l.style.overflow = "hidden");
}
const B = {
  s: 5,
  m: 10,
  l: 15
};
function le(e, l, a) {
  const n = u(() => e === "textarea"), r = u(() => B[l]);
  return {
    onInput: (d) => {
      if (n.value) {
        const o = d.target;
        a.emit(V, o.value), ee(o);
      }
    },
    rows: r,
    isTextarea: n
  };
}
const ae = M({
  name: "VFormField",
  components: {
    Field: q,
    VIcon: K,
    VIconButton: Q,
    VText: X
  },
  emits: ["change", "input", V, "iconClick"],
  inheritAttrs: !1,
  props: {
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    autocomplete: {
      type: String,
      default: ""
    },
    type: {
      type: [String],
      default: null
    },
    hintText: {
      type: String,
      default: null
    },
    enableShowPassword: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: String,
      default: ""
    },
    rules: {
      type: Function,
      default: () => !0
    },
    textareaSize: {
      type: [String],
      default: "m",
      validator: (e) => Object.keys(B).includes(e)
    },
    as: {
      type: String,
      default: "input",
      validator: (e) => ["input", "textarea"].includes(e)
    },
    setAsInvalid: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disableInvalidStyles: {
      type: Boolean,
      default: !1
    },
    iconSymbol: {
      type: String
    },
    clickableIcon: {
      type: Boolean,
      default: !1
    },
    suffix: {
      type: String,
      default: null
    },
    togglePasswordButtonAriaLabel: {
      type: String,
      default: null
    }
  },
  setup(e, l) {
    const { setAsInvalid: a, modelValue: n } = D(e), {
      errorMessage: r,
      handleBlur: b,
      handleChange: d,
      value: o,
      errors: v
    } = G(e.name, e.rules, {
      validateOnValueUpdate: !1,
      validateOnMount: !1,
      type: e.type,
      initialValue: n
    }), h = S(null);
    O(() => {
      n.value !== o.value && (o.value = n.value);
    }), U(n, (t) => {
      o.value = t;
    });
    const s = u(() => !!r && r.value !== void 0 || a.value), {
      handleShowHidePassword: C,
      fieldType: P,
      togglePasswordIcon: k,
      togglePasswordButtonLabel: T
    } = _(h, e), I = (t) => J(t, {
      allowedTags: [],
      allowedAttributes: []
    }), F = (t) => {
      const m = I(t.target.value);
      d(m), t.target.value = m, l.emit("change", t);
    }, A = (t) => {
      let m = I(t.target.value);
      e.type === "email" && (m = m.toLowerCase(), t.target.value = m, d(m)), l.emit("input", t);
    }, $ = u(() => ({
      symbol: s.value ? "alert" : null
    })), z = e.enableShowPassword ? k : $, { onInput: E, rows: L, isTextarea: H } = le(
      e.as,
      e.textareaSize,
      l
    ), N = u(() => !!l.slots.textareaAttachments);
    return {
      rows: L,
      isInvalid: s,
      errorMessage: r,
      icon: z,
      onInput: E,
      inputFieldRef: h,
      fieldType: P,
      handleShowHidePassword: C,
      togglePasswordButtonLabel: T,
      isTextarea: H,
      onChange: F,
      handleBlur: b,
      inputValue: o,
      handleInput: A,
      hasAttachments: N,
      errors: v
    };
  }
});
const oe = ["name", "id", "autocomplete", "type", "placeholder", "aria-describedby", "aria-invalid", "disabled", "value"], te = ["for"], ne = ["id"];
function se(e, l, a, n, r, b) {
  const d = y("Field"), o = y("VText"), v = y("VIcon"), h = y("VIconButton");
  return i(), c("div", {
    class: g(["hobi-form-input-field hobi-form-field", [
      e.isInvalid && !e.disableInvalidStyles ? "hobi-form-field--invalid" : "",
      e.label ? "" : "hobi-form-field--without-label"
    ]])
  }, [
    e.isTextarea ? (i(), f(d, {
      key: 0,
      id: e.id,
      name: e.name,
      autocomplete: e.autocomplete,
      rules: e.rules,
      "model-value": e.modelValue,
      label: e.label,
      placeholder: e.hintText,
      class: g(["hobi-textarea tw-resize-none", { "hobi-textarea--with-attachments tw-pb-16": e.hasAttachments }]),
      as: e.as,
      rows: e.rows,
      onInput: e.onInput,
      "aria-describedby": `hobi-${e.name}-error-message`,
      "aria-invalid": e.isInvalid,
      onChange: e.onChange,
      disabled: e.disabled
    }, null, 8, ["id", "name", "autocomplete", "rules", "model-value", "label", "placeholder", "class", "as", "rows", "onInput", "aria-describedby", "aria-invalid", "onChange", "disabled"])) : (i(), c("input", {
      key: 1,
      class: "hobi-input",
      name: e.name,
      id: e.id,
      autocomplete: e.autocomplete,
      type: e.fieldType,
      placeholder: e.hintText,
      "aria-describedby": `hobi-${e.name}-error-message`,
      "aria-invalid": e.isInvalid,
      disabled: e.disabled,
      ref: "inputFieldRef",
      value: e.inputValue,
      onChange: l[0] || (l[0] = (...s) => e.onChange && e.onChange(...s)),
      onInput: l[1] || (l[1] = (...s) => e.handleInput && e.handleInput(...s)),
      onBlur: l[2] || (l[2] = (...s) => e.handleBlur && e.handleBlur(...s))
    }, null, 40, oe)),
    e.iconSymbol && !e.isInvalid ? (i(), f(R(e.clickableIcon ? "VIconButton" : "VIcon"), {
      key: 2,
      symbol: e.iconSymbol,
      color: "#959595",
      size: 24,
      role: "presentation",
      onClick: l[3] || (l[3] = (s) => e.$emit("iconClick")),
      className: "hobi-icon"
    }, null, 8, ["symbol"])) : p("", !0),
    e.suffix ? (i(), f(o, {
      key: 3,
      class: "hobi-input-suffix tw-absolute",
      color: "grey-600",
      size: "s"
    }, {
      default: W(() => [
        Y(w(e.suffix), 1)
      ]),
      _: 1
    })) : p("", !0),
    e.icon.symbol !== null && !e.enableShowPassword && e.isInvalid && !e.disableInvalidStyles ? (i(), f(v, {
      key: 4,
      symbol: e.icon.symbol,
      color: "#959595",
      size: 24,
      role: "presentation",
      className: "hobi-icon"
    }, null, 8, ["symbol"])) : e.icon.symbol !== null && e.enableShowPassword ? (i(), f(h, {
      key: 5,
      symbol: e.icon.symbol,
      color: "#959595",
      size: 24,
      onClick: e.handleShowHidePassword,
      "aria-label": e.togglePasswordButtonAriaLabel,
      className: "hobi-icon"
    }, null, 8, ["symbol", "onClick", "aria-label"])) : p("", !0),
    j("label", {
      class: "hobi-label hobi-form-field-label tw-text-xs tw-leading-4",
      for: e.id
    }, w(e.label), 9, te),
    e.isInvalid && !e.disableInvalidStyles ? (i(), c("p", {
      key: 6,
      id: `hobi-${e.name}-error-message`,
      class: "hobi-form-field-message"
    }, w(e.errorMessage), 9, ne)) : p("", !0),
    e.isTextarea ? (i(), c("div", {
      key: 7,
      class: g(["hobi-textarea-attachments tw-absolute tw-left-0 tw-right-0 tw-bottom-0 tw-w-full", {
        "hobi-textarea-attachments--invalid-textarea": e.isInvalid && !e.disableInvalidStyles
      }])
    }, [
      Z(e.$slots, "textareaAttachments", {}, void 0, !0)
    ], 2)) : p("", !0)
  ], 2);
}
const ye = /* @__PURE__ */ x(ae, [["render", se], ["__scopeId", "data-v-ed7881bb"]]);
export {
  ye as default
};
